import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "pl-10 pr-10" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置 ")
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 使用中")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 闲置")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 报废")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_11 = { class: "d-flex justify-content--center" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("生命周期")
const _hoisted_14 = { class: "d-flex d-flex-row-reverse" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, " 资产详情 ", -1)
const _hoisted_16 = { class: "d-flex mt-20" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1)
const _hoisted_19 = { class: "d-flex mt-20" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1)
const _hoisted_22 = { class: "d-flex mt-20" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1)
const _hoisted_25 = { class: "d-flex mt-20" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1)
const _hoisted_28 = { class: "d-flex mt-20" }
const _hoisted_29 = { class: "flex-1" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_32 = { class: "w-75 mt-20" }
const _hoisted_33 = { class: "d-flex" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1)
const _hoisted_35 = { class: "d-flex" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_38 = { class: "w-75 mt-20" }
const _hoisted_39 = { class: "d-flex" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1)
const _hoisted_41 = { class: "d-flex" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_44 = { class: "w-75 mt-20" }
const _hoisted_45 = { class: "d-flex" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1)
const _hoisted_47 = { class: "d-flex" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_51 = { class: "mt-20" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", null, " 固定资产生命周期 ", -1)
const _hoisted_53 = { style: {"margin-top":"-30px"} }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", null, "入库单号：", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "ml-20" }, "入库时间：", -1)

import {computed, onBeforeMount, reactive, ref, watch} from "vue";
import tbMix from "@/global_mixin/tableMixin";
import {
  type_fixed,
  fixed_asset_status_using,
  fixed_asset_status_idle,
  fixed_asset_status_discard,
} from "@/views/ViewsComponents/officeAssets/OfficeAssetUtils";
import {exportHandle} from "@/utils";
import {ElMessage} from "element-plus";


export default /*#__PURE__*/_defineComponent({
  props: {
    orgList: null,
    categoryList: null,
    companyList: null,
    assetSearchApi: null,
    assetDetailApi: null,
    assetLifeCycleApi: null,
    fixedAssetCountApi: null,
    exportApi: null
  },
  setup(__props: any) {

const props = __props as {
  orgList: any[],
  categoryList: any[],
  companyList: any[],
  assetSearchApi: (param: any, opt: object) => Promise<any>,
  assetDetailApi: (param: any) => Promise<any>,
  assetLifeCycleApi: (param: any) => Promise<any>,
  fixedAssetCountApi: (param: any) => Promise<any>,
  exportApi: (param: any) => Promise<any>,

}

const tabMaxHeight = ref("520px")

const assetCountByStatus = reactive({
  [fixed_asset_status_using]: 0,
  [fixed_asset_status_idle]: 0,
  [fixed_asset_status_discard]: 0,
})
const assetCount = computed(() => {
  return assetCountByStatus[fixed_asset_status_using] + assetCountByStatus[fixed_asset_status_idle] + assetCountByStatus[fixed_asset_status_discard]
})

const searchEle = ref()
const searchObj = reactive<{
  orgId: null | number,
  companyId: null | number,
  assetNo: null | string,
  categoryNo: null | string,
  status: string
}>({
  orgId: null,
  companyId: null,
  assetNo: null,
  categoryNo: null,
  status: ''
})
const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(props.assetSearchApi)
onBeforeMount(() => {
  searchAsset()
})
watch(() => searchObj.status, (cur, old) => {
  searchAsset()
})

const searchAsset = () => {
  page.value = 1
  fetchData({
    ...searchObj,
    type: type_fixed,
  })
  props.fixedAssetCountApi({
    orgId: searchObj.orgId,
    assetNo: searchObj.assetNo,
    categoryNo: searchObj.categoryNo,
    companyId: searchObj.companyId
  }).then((r: any) => {
    assetCountByStatus[fixed_asset_status_using] = r[fixed_asset_status_using]
    assetCountByStatus[fixed_asset_status_idle] = r[fixed_asset_status_idle]
    assetCountByStatus[fixed_asset_status_discard] = r[fixed_asset_status_discard]
  })
}
const extraActiveItem = ref("LY")
const lifeCycleDialogInfo = reactive<{
  isShow: boolean,
  asset: any,
  list: any[],
  rkItem: any,
}>({
  isShow: false,
  asset: null,
  list: [],
  rkItem: {}
})
const fixedAssetDetailDialogInfo = reactive<{
  isShow: boolean,
  asset: any,
}>({
  isShow: false,
  asset: null,
})

const showLifeCycleDialog = (asset: any) => {
  lifeCycleDialogInfo.asset = asset
  lifeCycleDialogInfo.isShow = true
  props.assetLifeCycleApi({id: asset.id}).then((r: any[]) => {
    lifeCycleDialogInfo.rkItem = r.filter((it) => it.type == "REGISTRATION")[0]
    lifeCycleDialogInfo.list = r.filter((it) => it.type != "REGISTRATION")
  }).catch((e) => {

  })

}
const assetDetail = (row: any) => {
  props.assetDetailApi({id: row.id}).then((r: any) => {
    extraActiveItem.value = "LY"
    if (r.categoryDepreciationMethod == "NONE") {
      r.extra.financeInfo.monthlyDepreciationAmount = "-";
      r.extra.financeInfo.countOfMonth = "-";
      r.extra.financeInfo.depreciationAmount = "-";
    }

    fixedAssetDetailDialogInfo.asset = r

    fixedAssetDetailDialogInfo.isShow = true
  })
}
const exporting = ref<Boolean>(false)
const exportExcel = () => {
  exporting.value = true
  const obj = {
    orgId: searchObj.orgId ? searchObj.orgId : "",
    companyId: searchObj.companyId ? searchObj.companyId : "",
    assetNo: searchObj.assetNo ? searchObj.assetNo : "",
    categoryNo: searchObj.categoryNo ? searchObj.categoryNo : "",
    status: searchObj.status ? searchObj.status : "",
    type: type_fixed,
  }
  exportHandle(props.exportApi, obj, {contentType: 'formData'}).then(() => {
    exporting.value = false
    ElMessage.success('导出成功')
  }).finally(() => {
    exporting.value = false
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_collapse, { class: "mb-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, {
          title: "搜索",
          name: "1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              class: "searchContent searchBg",
              disabled: _unref(MI_identify),
              model: _unref(searchObj),
              "label-width": "90px",
              inline: true,
              ref_key: "searchEle",
              ref: searchEle,
              "label-position": "right"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "所属团队:",
                  prop: "orgId",
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).orgId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).orgId) = $event)),
                      placeholder: "所属团队",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.orgList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "所属公司:",
                  prop: "companyId",
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).companyId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).companyId) = $event)),
                      placeholder: "所属公司",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysCompany, (group) => {
                          return (_openBlock(), _createBlock(_component_el_option_group, {
                            label: group.label,
                            key: group.label
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.name,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "资产编号:",
                  prop: "assetNo",
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).assetNo ,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).assetNo ) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "资产类别:",
                  prop: "categoryNo",
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).categoryNo,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchObj).categoryNo) = $event)),
                      placeholder: "资产类别",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categoryList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.no,
                            label: item.name,
                            value: item.no
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (searchAsset()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => {searchEle.value.resetFields();})
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled", "model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_radio_group, {
        modelValue: _unref(searchObj).status,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(searchObj).status) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio_button, { label: '' }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createElementVNode("span", null, _toDisplayString(_unref(assetCount)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_radio_button, { label: _unref(fixed_asset_status_using) }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createElementVNode("span", null, _toDisplayString(_unref(assetCountByStatus)[_unref(fixed_asset_status_using)]), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_radio_button, { label: _unref(fixed_asset_status_idle) }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createElementVNode("span", null, _toDisplayString(_unref(assetCountByStatus)[_unref(fixed_asset_status_idle)]), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_radio_button, { label: _unref(fixed_asset_status_discard) }, {
            default: _withCtx(() => [
              _hoisted_8,
              _createElementVNode("span", null, _toDisplayString(_unref(assetCountByStatus)[_unref(fixed_asset_status_discard)]), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _hoisted_9,
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: exporting.value,
        loading: exporting.value,
        onClick: exportExcel
      }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["disabled", "loading"])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "fixedAssetStatisticalEle",
      border: "",
      class: "mt-10",
      data: _unref(MI_tableData),
      "row-key": "id",
      "max-height": tabMaxHeight.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "固定资产编号",
          prop: "no",
          width: "210",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "所属团队",
          prop: "orgName",
          width: "160"
        }),
        _createVNode(_component_el_table_column, {
          label: "所属公司",
          prop: "companyName",
          "show-overflow-tooltip": "",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          label: "资产名称",
          prop: "name",
          "show-overflow-tooltip": "",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "规格型号",
          prop: "spec",
          width: "100",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "电脑设备ID",
          prop: "deviceId",
          width: "120",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "资产类别",
          prop: "categoryName",
          width: "100",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "单位",
          prop: "unit",
          width: "60"
        }),
        _createVNode(_component_el_table_column, {
          label: "数量",
          prop: "count",
          width: "60"
        }),
        _createVNode(_component_el_table_column, { label: "领用信息" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "领用日期",
              prop: "ownerDate",
              width: "120"
            }),
            _createVNode(_component_el_table_column, {
              label: "领用人",
              prop: "ownerName",
              width: "120",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "资产变动单号",
              prop: "lastAssetChangeNo",
              width: "210"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "使用状态",
          prop: "statusDesc",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "存放位置",
          prop: "place",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "管理员",
          prop: "managerName",
          width: "120",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, { label: "采购信息" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "采购日期",
              prop: "purchasingDate",
              width: "120"
            }),
            _createVNode(_component_el_table_column, {
              label: "采购人",
              prop: "purchasingUserName",
              width: "120",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "币种",
              prop: "purchasingCurrency",
              width: "120",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "采购价格",
              prop: "purchasingPrice",
              align: "right",
              width: "120"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "备注",
          prop: "note",
          "show-overflow-tooltip": "",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right",
          width: "160"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_space, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_link, {
                    type: "primary",
                    onClick: ($event: any) => (assetDetail(row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_el_space, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_link, {
                    type: "primary",
                    onClick: ($event: any) => (showLifeCycleDialog(row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_el_pagination, {
        disabled: _unref(MI_identify),
        background: "",
        small: "",
        total: _unref(MI_total),
        currentPage: _unref(page),
        "onUpdate:currentPage": _cache[7] || (_cache[7] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
        "page-size": _unref(size),
        "onUpdate:page-size": _cache[8] || (_cache[8] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
        class: "mt-10",
        "page-sizes": [10, 30, 50, 100, 300, 1000],
        layout: "sizes, prev, pager, next, total, jumper",
        onCurrentChange: _unref(MI_pageChange),
        onSizeChange: _unref(MI_sizeChange)
      }, null, 8, ["disabled", "total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
    ]),
    _createVNode(_component_el_dialog, {
      class: "fixedAssetDetailDialog",
      modelValue: _unref(fixedAssetDetailDialogInfo).isShow,
      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).isShow) = $event)),
      draggable: "",
      width: "1200px"
    }, {
      header: _withCtx(() => [
        _hoisted_15
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "fixedAssetDetailForm",
          ref: "fixedAssetDetailFormRef",
          model: _unref(fixedAssetDetailDialogInfo).asset
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_el_form_item, {
                label: "所属团队",
                prop: "orgName",
                class: "flex-1",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(fixedAssetDetailDialogInfo).asset.orgName,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.orgName) = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _hoisted_17,
              _createVNode(_component_el_form_item, {
                label: "所属公司",
                prop: "companyName",
                class: "flex-1",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(fixedAssetDetailDialogInfo).asset.companyName,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.companyName) = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _hoisted_18,
              _createVNode(_component_el_form_item, {
                label: "固定资产编码",
                prop: "no",
                class: "flex-1",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(fixedAssetDetailDialogInfo).asset.no,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.no) = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_el_form_item, {
                label: "旧编号",
                prop: "inputNo",
                class: "flex-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(fixedAssetDetailDialogInfo).asset.inputNo,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.inputNo) = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _hoisted_20,
              _createVNode(_component_el_form_item, {
                label: "资产名称",
                prop: "name",
                class: "flex-1",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(fixedAssetDetailDialogInfo).asset.name,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.name) = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _hoisted_21,
              _createVNode(_component_el_form_item, {
                label: "规格型号",
                prop: "extra.spec",
                class: "flex-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(fixedAssetDetailDialogInfo).asset.extra.spec,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.extra.spec) = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_el_form_item, {
                label: "电脑设备ID",
                prop: "extra.deviceId",
                class: "flex-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(fixedAssetDetailDialogInfo).asset.extra.deviceId,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.extra.deviceId) = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _hoisted_23,
              _createVNode(_component_el_form_item, {
                label: "资产类别",
                prop: "categoryName",
                class: "flex-1",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(fixedAssetDetailDialogInfo).asset.categoryName,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.categoryName) = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _hoisted_24,
              _createVNode(_component_el_form_item, {
                label: "单位",
                prop: "extra.unit",
                class: "flex-1",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(fixedAssetDetailDialogInfo).asset.extra.unit,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.extra.unit) = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_el_form_item, {
                label: "数量",
                prop: "extra.count",
                class: "flex-1",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(fixedAssetDetailDialogInfo).asset.extra.count,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.extra.count) = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _hoisted_26,
              _createVNode(_component_el_form_item, {
                label: "使用状态",
                prop: "statusDesc",
                class: "flex-1",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(fixedAssetDetailDialogInfo).asset.statusDesc,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.statusDesc) = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _hoisted_27,
              _createVNode(_component_el_form_item, {
                label: "存放位置",
                prop: "extra.place",
                class: "flex-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(fixedAssetDetailDialogInfo).asset.extra.place,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.extra.place) = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_el_form_item, {
                  label: "管理员",
                  prop: "managerName",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(fixedAssetDetailDialogInfo).asset.managerName,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.managerName) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _hoisted_30,
              _createVNode(_component_el_form_item, {
                label: "备注",
                prop: "note",
                class: "flex-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(fixedAssetDetailDialogInfo).asset.extra.note,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.extra.note) = $event)),
                    type: "textarea",
                    autosize: { minRows: 3},
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _hoisted_31,
            _createVNode(_component_el_tabs, {
              modelValue: extraActiveItem.value,
              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((extraActiveItem).value = $event)),
              class: "mt-20",
              type: "card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: "领用信息",
                  name: "LY"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(_component_el_form_item, {
                          label: "资产变动单号",
                          prop: "lyChangeNo",
                          class: "flex-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(fixedAssetDetailDialogInfo).asset.lyChangeNo,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.lyChangeNo) = $event)),
                              placeholder: "",
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _hoisted_34,
                        _createVNode(_component_el_form_item, {
                          label: "领用日期",
                          prop: "extra.start",
                          class: "flex-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(fixedAssetDetailDialogInfo).asset.start,
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.start) = $event)),
                              placeholder: "",
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_el_form_item, {
                          prop: "ownerId",
                          label: "领用人"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(fixedAssetDetailDialogInfo).asset.ownerName,
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.ownerName) = $event)),
                              placeholder: "",
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _hoisted_36,
                        _hoisted_37
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "财务信息",
                  name: "CW"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(_component_el_form_item, {
                          label: "月折旧额",
                          prop: "extra.financeInfo.monthlyDepreciationAmount",
                          class: "flex-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(fixedAssetDetailDialogInfo).asset.extra.financeInfo.monthlyDepreciationAmount,
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.extra.financeInfo.monthlyDepreciationAmount) = $event)),
                              placeholder: "",
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _hoisted_40,
                        _createVNode(_component_el_form_item, {
                          label: "折旧累计月份",
                          prop: "extra.financeInfo.countOfMonth",
                          class: "flex-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(fixedAssetDetailDialogInfo).asset.extra.financeInfo.countOfMonth,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.extra.financeInfo.countOfMonth) = $event)),
                              placeholder: "",
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createVNode(_component_el_form_item, {
                          prop: "extra.financeInfo.depreciationAmount",
                          label: "累计折旧额",
                          class: "flex-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(fixedAssetDetailDialogInfo).asset.extra.financeInfo.depreciationAmount,
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.extra.financeInfo.depreciationAmount) = $event)),
                              placeholder: "",
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _hoisted_42,
                        _hoisted_43
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "采购信息",
                  name: "CG"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createVNode(_component_el_form_item, {
                          prop: "purchasingUserName",
                          label: "采购人",
                          required: "",
                          class: "flex-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(fixedAssetDetailDialogInfo).asset.purchasingUserName,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.purchasingUserName) = $event)),
                              placeholder: "",
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _hoisted_46,
                        _createVNode(_component_el_form_item, {
                          label: "币种",
                          prop: "extra.purchasingInfo.currency",
                          class: "flex-1",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(fixedAssetDetailDialogInfo).asset.extra.purchasingInfo.currency,
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.extra.purchasingInfo.currency) = $event)),
                              class: "",
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_el_form_item, {
                          label: "采购价格",
                          prop: "extra.purchasingInfo.price",
                          class: "flex-1",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(fixedAssetDetailDialogInfo).asset.extra.purchasingInfo.price,
                              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.extra.purchasingInfo.price) = $event)),
                              class: "price-input",
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _hoisted_48,
                        _createVNode(_component_el_form_item, {
                          label: "采购日期",
                          prop: "extra.purchasingInfo.date",
                          class: "flex-1",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(fixedAssetDetailDialogInfo).asset.extra.purchasingInfo.date,
                              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(fixedAssetDetailDialogInfo).asset.extra.purchasingInfo.date) = $event)),
                              placeholder: "",
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _hoisted_49,
                        _hoisted_50
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "捆绑资产",
                  name: "KB"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(_component_el_table, {
                        border: "",
                        class: "mt-10",
                        data: _unref(fixedAssetDetailDialogInfo).asset.bindAssets,
                        "row-key": "id",
                        "max-height": "200px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            label: "序号",
                            type: "index",
                            width: "70"
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "所属团队",
                            prop: "orgName",
                            width: "100"
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "所属公司",
                            prop: "companyName",
                            width: "180"
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "资产编号",
                            prop: "no",
                            width: "200"
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "资产名称",
                            prop: "name",
                            width: "120"
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "规格型号",
                            prop: "spec",
                            width: "100"
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "电脑设备ID",
                            prop: "deviceId",
                            width: "120"
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "资产类别",
                            prop: "categoryName",
                            width: "100"
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "单位",
                            prop: "unit",
                            width: "60"
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "数量",
                            prop: "count",
                            width: "60"
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "使用状态",
                            prop: "statusDesc",
                            width: "100"
                          })
                        ]),
                        _: 1
                      }, 8, ["data"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "fixedAssetLifeCycleDialog",
      modelValue: _unref(lifeCycleDialogInfo).isShow,
      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_unref(lifeCycleDialogInfo).isShow) = $event)),
      draggable: "",
      width: "1000px"
    }, {
      header: _withCtx(() => [
        _hoisted_52
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", null, [
            _hoisted_54,
            _createElementVNode("span", null, _toDisplayString(_unref(lifeCycleDialogInfo).rkItem.no), 1),
            _hoisted_55,
            _createElementVNode("span", null, _toDisplayString(_unref(lifeCycleDialogInfo).rkItem.changeDate), 1)
          ]),
          _createVNode(_component_el_table, {
            ref: "fixedAssetLifeCycleTable",
            data: _unref(lifeCycleDialogInfo).list,
            class: "mt-10",
            "row-key": "id"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "序号",
                type: "index",
                width: "60",
                fixed: ""
              }),
              _createVNode(_component_el_table_column, {
                label: "资产变动单号",
                prop: "no",
                width: "300",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "变动类型",
                prop: "typeDesc",
                width: "120",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "日期",
                prop: "changeDate",
                width: "160",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "领用人/退库人",
                prop: "ownerUserName",
                width: "160",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "经办人",
                prop: "operatorUserName",
                width: "160",
                "show-overflow-tooltip": ""
              })
            ]),
            _: 1
          }, 8, ["data"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})